<template>
  <div class="pint7x4reverse">
    <div class="label-content">
      <div class="name">お取り扱い上のご注意：
      </div>
      <div class="content">
        <div v-html="printData.desc"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    printData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  },

  methods: {

  }
}
</script>

<style scoped lang="scss">
.pint7x4reverse {
  width: 794px;
  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;

  .label-content {
    width: 630px;
    padding: 40px 20px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 28px;

    .name {
      margin-bottom: 40px;
    }
  }
}
</style>